export function detectDeviceInfo() {
  const ua = navigator.userAgent;

  const device_type = /Android/i.test(ua)
    ? "android"
    : /iPhone|iPad|iPod/i.test(ua)
    ? "ios"
    : "web";

  return {
    device_type,
    browser: ua,
  };
}
